/* ==========================================================================
   BodenWerk – Muster in den Warenkorb, ohne die Seite zu verlassen

   Wer mehrere Dekore vergleichen will, soll nach jedem Muster nicht erst
   im Warenkorb landen. Das Formular geht per /cart/add.js raus, der Zaehler
   im Header wird ueber die Section Rendering API erneuert und unter dem Knopf
   erscheint eine Bestaetigung. Ohne JavaScript oder bei Fehlern laeuft das
   normale Formular weiter (Weiterleitung in den Warenkorb).
   ========================================================================== */
(function () {
  'use strict';

  function headerSectionId() {
    var bubble = document.getElementById('cart-icon-bubble');
    var sec = bubble && bubble.closest('.shopify-section');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-bw-muster-form="muster"]');
    if (!form || form.__bwSendet) return;
    e.preventDefault();

    var knopf = form.querySelector('[type="submit"]');
    var hinweis = document.querySelector('[data-bw-muster-ok]');
    var headerId = headerSectionId();
    var daten = new FormData(form);
    if (headerId) {
      daten.append('sections', headerId);
      daten.append('sections_url', window.location.pathname);
    }

    form.__bwSendet = true;
    if (knopf) knopf.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: daten })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function (antwort) {
        if (headerId && antwort.sections && antwort.sections[headerId]) {
          var kopf = new DOMParser().parseFromString(antwort.sections[headerId], 'text/html');
          var alt = document.getElementById('cart-icon-bubble');
          var frisch = kopf.getElementById('cart-icon-bubble');
          if (alt && frisch) alt.innerHTML = frisch.innerHTML;
        }
        if (hinweis) {
          hinweis.hidden = false;
          hinweis.focus();
        }
        form.__bwSendet = false;
        if (knopf) knopf.removeAttribute('aria-busy');
        if (window.bwEreignis) window.bwEreignis.melde('bw_muster_im_warenkorb', {});
      })
      .catch(function () {
        // Rueckfall: normales Absenden mit Weiterleitung in den Warenkorb
        form.__bwSendet = true;
        form.submit();
      });
  });
})();
